import React from 'react';
import { BsChatFill } from 'react-icons/bs';
import { IconButton } from '@chakra-ui/react';

import useChatContext from 'hooks/session/useChatContext';

const ToggleChatButton: React.FC = () => {
  const {
    isChatWindowOpen,
    setIsChatWindowOpen,
    conversation,
  } = useChatContext();

  const toggleChatWindow = (): void => {
    setIsChatWindowOpen(!isChatWindowOpen);
  };

  return (
    <IconButton
      aria-label="Toggle Chat"
      data-cy-chat-button
      onClick={toggleChatWindow}
      disabled={!conversation}
      icon={<BsChatFill />}
    />
  );
};

export default ToggleChatButton;
